<script setup>
  import { onMounted, onUnmounted } from 'vue'

  import HamburgerMenuMobileGroup from '@/features/layout/components/hamburgerMobile/HamburgerMenuMobileGroup.vue'
  import { useLayoutStore } from '@/features/layout/useLayoutStore.js'
  import { useScrollLock } from '@/features/ui/hooks/useScrollLock.js'

  const layoutStore = useLayoutStore()

  onMounted(() => {
    useScrollLock().lock()
  })

  onUnmounted(() => {
    useScrollLock().unlock()
  })
</script>

<template>
  <div class="sidebar-menu-mobile">
    <nav class="sidebar-panel-nav-mobile">
      <ul>
        <HamburgerMenuMobileGroup
          v-for="item of layoutStore.sidebarMenuItems"
          :key="item.to"
          :item="item"
        />
      </ul>
    </nav>
  </div>
</template>

<style lang="scss" scoped>
  .sidebar-menu-mobile {
    position: fixed;
    top: 60px;
    background: var(--fm-ui-hamburger-background-color);
    z-index: 100;
    left: 0;
    right: 0;
    max-height: calc(100vh - 60px);
    overflow-y: auto;

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }
  }
</style>
